import { formataData } from 'common/utils/date'

import {
  ErrorMappingInterface,
  ValidationFormErrorInterface
} from './interfaces'
const translations = {
  agency: {
    cnpj: 'CNPJ',
    cnpjHelper: 'Formato: XX.XXX.XXX/XXXX-XX',
    edit: 'Editar dados da imobiliária',
    name: 'Nome',
    nameHelper: 'Nome oficial conforme documentos',
    addressHelper: 'Rua, número, bairro, cidade – UF',
    sectionData: 'Dados cadastrais',
    sectionContact: 'Contato',
    sectionLogo: 'Identidade visual',
    fantasyName: 'Nome Fantasia',
    fantasyNameHelper: 'Nome comercial da imobiliária',
    creci: 'CRECI',
    creciHelper: 'Registro no Conselho Regional de Corretores de Imóveis',
    phone: 'Telefone',
    phoneHelper: 'DDD + número',
    email: 'E-mail',
    emailHelper: 'E-mail institucional da imobiliária',
    website: 'Website',
    websiteHelper: 'URL do site (ex: www.suaimobiliaria.com.br)',
    instagram: 'Instagram',
    instagramHelper:
      'URL do perfil no Instagram (ex: https://www.instagram.com/suaimobiliaria)',
    facebook: 'Facebook',
    facebookHelper:
      'URL da página no Facebook (ex: https://www.facebook.com/suaimobiliaria)',
    youtube: 'YouTube',
    youtubeHelper:
      'URL do canal no YouTube (ex: https://www.youtube.com/@suaimobiliaria)',
    tiktok: 'TikTok',
    tiktokHelper:
      'URL do perfil no TikTok (ex: https://www.tiktok.com/@suaimobiliaria)',
    linkedin: 'LinkedIn',
    linkedinHelper:
      'URL da página no LinkedIn (ex: https://www.linkedin.com/company/suaimobiliaria)',
    title: 'Imobiliária',
    logo: 'Logo da imobiliária',
    logoDescription:
      "Utilizada como marca d'água nas fotos dos imóveis. Apenas arquivos PNG.",
    logoUpload: 'Enviar logo',
    logoUpdate: 'Atualizar logo',
    logoSuccess: 'Logo atualizada com sucesso',
    logoError: 'Erro ao enviar logo. Tente novamente.',
    logoNoFile: 'Sem logo cadastrada',
    logoSelectFile: 'Selecionar arquivo PNG',
    logoFileSelected: 'Arquivo selecionado'
  },
  leads: {
    title: 'Leads',
    add: 'Cadastrar lead',
    edit: 'Editar lead',
    gestao: 'Gestão de Leads',
    historico: 'Histórico de Leads',
    roleta: 'Roleta de Leads',
    listagemHistorico: 'Listagem de histórico',
    data: 'Data',
    codImovel: 'Cód do imóvel',
    status: 'Status',
    nome: 'Nome',
    actions: 'Ações',
    cadastrar: 'Cadastrar Lead',
    imovel: 'Imóvel',
    telefone: 'Telefone',
    email: 'E-mail',
    origem: 'Origem',
    whatsApp: 'WhatsApp',
    interesse: 'Interesse',
    cancelar: 'Cancelar',
    salvar: 'Salvar Lead',
    buscar: 'Buscar',
    analiseContrato: 'Análise de Documento'
  },
  reports: {
    brokerProductivity: {
      menu: 'Produtividade',
      menuSelf: 'Meu desempenho',
      title: 'Produtividade por corretor',
      titleSelf: 'Meu desempenho',
      subtitle:
        'Números de cada corretor no período, comparados à mediana da equipe',
      exportButton: 'Exportar',
      exportCsv: 'CSV',
      exportXlsx: 'Excel (XLSX)',
      exportFileName: 'produtividade-corretores',
      exportSheetName: 'Produtividade',
      teamRow: 'Equipe (mediana)',
      unassignedRow: 'Sem corretor',
      inactive: 'Inativo',
      smallSample: 'amostra pequena',
      aboveMedian: 'Mais de 25% melhor que a mediana da equipe',
      belowMedian: 'Mais de 25% pior que a mediana da equipe',
      columns: {
        name: 'Corretor',
        leadsAssigned: 'Leads',
        leadsWon: 'Ganhos',
        conversionRate: 'Conversão',
        firstResponse: '1ª resposta (mediana)',
        leadsWithoutContact: 'Sem contato',
        activitiesPerLead: 'Interações/lead',
        visits: 'Visitas (realizadas/agendadas)',
        attendanceRate: 'Comparecimento',
        visitsPendingClose: 'Pendentes de baixa',
        overdueNextActions: 'Ações vencidas',
        proposals: 'Propostas (convertidas/geradas)'
      },
      tooltips: {
        name: 'Quem era o responsável pelo lead. Linhas com corretores da roleta e com quem teve algum número no período.',
        leadsAssigned:
          'Leads que passaram a ser deste corretor no período, pela roleta, manualmente ou em lote. Uma reatribuição conta para os dois.',
        leadsWon:
          'Leads que entraram numa etapa de venda ganha no período enquanto este corretor era o responsável.',
        conversionRate:
          'Ganhos no período divididos pelos leads recebidos no período.',
        firstResponse:
          'Tempo típico entre receber o lead e registrar a primeira interação (ligação, WhatsApp, e-mail, visita) na plataforma. Metade dos leads foi respondida em menos tempo que isso. Menor é melhor.',
        leadsWithoutContact:
          'Leads recebidos no período que continuam com o corretor e ainda não têm nenhuma interação registrada por ele.',
        activitiesPerLead:
          'Interações registradas pelo corretor no período divididas pelo número de leads diferentes em que ele interagiu.',
        visits:
          'Visitas da agenda com este corretor como responsável e data no período: realizadas / agendadas (canceladas não contam).',
        attendanceRate:
          'Visitas realizadas divididas pelas visitas com baixa (realizadas + não comparecimento). As que ainda estão sem baixa ficam de fora.',
        visitsPendingClose:
          'Visitas com data já passada que ainda estão como agendadas ou confirmadas: falta marcar se aconteceram.',
        overdueNextActions:
          'Situação de hoje: leads abertos deste corretor com a data da próxima ação já vencida. Não depende do período.',
        proposals:
          'Propostas ligadas a leads deste corretor: convertidas em contrato no período / criadas no período. A ligação é feita pelo imóvel e pelo e-mail ou telefone do cliente.'
      },
      kpis: {
        conversionRate: 'Conversão da equipe',
        conversionDetail: (won: number, assigned: number) =>
          `${won} ganhos de ${assigned} leads`,
        firstResponse: '1ª resposta (mediana)',
        firstResponseDetail: (sample: number) =>
          `${sample} ${sample === 1 ? 'lead respondido' : 'leads respondidos'}`,
        attendanceRate: 'Comparecimento em visitas',
        attendanceDetail: (completed: number, closed: number) =>
          `${completed} de ${closed} visitas com baixa`,
        proposalsConverted: 'Propostas convertidas',
        proposalsDetail: (created: number) => `${created} geradas no período`
      },
      drawer: {
        close: 'Fechar',
        comparison: 'Comparação com a mediana da equipe',
        broker: 'Corretor',
        team: 'Equipe (mediana)',
        details: 'Números do período',
        noShow: 'Não compareceram',
        activities: 'Interações registradas',
        leadsTouched: 'Leads com interação',
        firstResponseAvg: '1ª resposta (média)'
      },
      footer: (date: string | null) =>
        date
          ? `Tempo de resposta e interações contam a partir de ${date}; o histórico anterior é aproximado.`
          : 'Tempo de resposta e interações: o histórico anterior à atualização é aproximado.',
      empty: 'Nenhum lead, visita ou proposta no período.',
      error: 'Não foi possível carregar a produtividade do período.',
      retry: 'Tentar novamente',
      invalidPeriod:
        'Período inválido: a data inicial precisa ser anterior ou igual à data final.',
      periodTooLong: (days: number) =>
        `Período longo demais: escolha no máximo ${days} dias.`
    }
  },
  banners: {
    commercialType: {
      button: 'Ver todos os imóveis',
      title: 'Olá empreendedor!',
      titleComplement: 'Procura um local para sua empresa?'
    },
    helloStudent: {
      button: 'Ver todos os imóveis',
      title: 'Olá estudante!',
      titleComplement: 'Procura um apê bem localizado?'
    },
    rightPlace: {
      button: 'Anunciar meu imóvel',
      title: 'Seu imóvel bem cuidado e sempre valorizado.',
      subtitle:
        'Cadastre gratuitamente e conte com nossa equipe para cuidar de visitas, contratos e locação.'
    },
    simpleRent: {
      button: 'Cadastre seu imóvel',
      title: 'Alugue seu imóvel de forma rápida e simples',
      subtitle: 'Alugar seu imóvel nunca foi tão fácil'
    },
    quickRent: {
      button: 'Faça uma proposta',
      title: 'Agilidade e facilidade',
      subtitle:
        'Sem burocracia na hora de alugar um imóvel próximo de faculdades e mercados'
    }
  },
  contracts: {
    add: 'Novo contrato',
    copasaCemig: 'Copasa/Cemig',
    create: 'Gerar contrato',
    deliveryOfKeys: 'Entrega das chaves e manual',
    digitalizedContract: 'Contrato digitalizado',
    edit: 'Editar Contrato',
    entryInspection: 'Inspeção',
    entryInspectionSignature: 'Aprovação da Inspeção',
    registrationData: 'Dados do contrato',
    rentPaymentDay: 'Dia do pagamento',
    status: {
      filling: 'Em Preenchimento',
      awaiting_signature: 'Aguardando Assinatura',
      active: 'Ativo',
      in_legal: 'Jurídico',
      in_vacancy: 'Em Desocupação',
      terminated: 'Rescindido'
    } as Record<string, string>,
    tenantAssignedContract: 'Assinatura do locatário',
    tenantBirthplace: 'Local de nascimento',
    tenantCountryOfBirth: 'Nacionalidade',
    tenantDocuments: 'Documentos do locatário',
    tenantMaritalStatus: 'Estado civil',
    tenantOccupation: 'Ocupação',
    title: 'Contratos',
    open: 'Abrir contrato',
    ownerAssignedContract: 'Assinatura do locador',
    body: 'Corpo do contrato',
    useTemplate: 'Usar modelo',
    insertSignature: 'Inserir assinatura'
  },
  contractTemplates: {
    title: 'Modelos de Contrato',
    add: 'Novo modelo',
    edit: 'Editar modelo',
    name: 'Nome do modelo',
    description: 'Descrição',
    content: 'Corpo do contrato',
    type: 'Tipo',
    variables: 'Variáveis disponíveis',
    insertVariable: 'Inserir variável',
    confirmDelete: 'Tem certeza que deseja excluir este modelo?',
    types: {
      TENANT: 'Locação',
      OWNER: 'Proprietário',
      CUSTOM: 'Personalizado'
    } as Record<string, string>
  },
  documents: {
    title: 'Documentos',
    add: 'Novo documento',
    types: {
      LAUDO: 'Laudo',
      TERMO: 'Termo',
      AUTORIZACAO: 'Autorização',
      CERTIDAO: 'Certidão',
      VISTORIA_ENTRADA: 'Vistoria de entrada',
      VISTORIA_SAIDA: 'Vistoria de saída',
      OUTROS: 'Outros'
    } as Record<string, string>
  },
  dashboard: {
    activeProperties: 'Imóveis ativos',
    activeContracts: 'Contratos ativos',
    canceledContracts: 'Contratos cancelados',
    closedContracts: 'Contratos fechados',
    realEstateCollected: 'Imóveis captados',
    lastCreatedProperties: 'Últimos imóveis cadastrados',
    newProperties: 'Imóveis captados',
    title: 'Dashboard'
  },
  employee: {
    add: 'Novo funcionário',
    edit: 'Editar funcionário'
  },
  errors: {
    currencyRegex: 'Formato inválido para um campo monetário - X,XX',
    errorEmail: 'Este e-mail já foi cadastrado',
    errorCreateUser: 'Erro ao criar usuário',
    errorLoadUsers: 'Erro ao carregar a lista de usuários',
    errorLoadPickupUsers: 'Erro ao carregar a lista de captadores',
    errorBoundary: 'Ops... Aconteceu um erro... Tente novamente.',
    expiredToken: 'Token expirado',
    fileLimit: (size: string) => `O tamanho máximo do arquivo deve ser ${size}`,
    floatRegex: 'Formato inválido para um campo percentual - X,XX',
    userAlreadyExists: 'Já existe um usuário com este e-mail',
    missingPermission: 'Você não possui permissão para acessar este recurso',
    fileType: (name: string) => `O tipo de arquivo "${name}" não é permitido.`
  },
  exceptions: {
    UsernameExistsException: 'Já existe um usuário com este e-mail',
    UserMissingPermissionException:
      'Você não possui permissão para acessar este recurso',
    PasswordResetRequiredException: 'Necessário resetar sua senha',
    InvalidPasswordFormatException:
      'A senha deve conter pelo menos 8 caracteres, 1 letra maiúscula, 1 letra minúscula e 1 caractere especial',
    UserNotFoundExistsException: 'Usuário não encontrado',
    RealEstateNotFoundExistsException: 'Imóvel não encontrado',
    InvalidCredentialsException: 'E-mail ou senha incorretos.'
  },
  financial: {
    title: 'Financeiro'
  },
  form: {
    errors: {
      badInput: () => `Formato inválido`,
      patternMismatch: (error: ValidationFormErrorInterface) =>
        `${inputNameFormat(error.inputName)} inválido`,
      tooLong: (error: ValidationFormErrorInterface) =>
        `Digite até ${error.maxLength} caracteres`,
      tooShort: (error: ValidationFormErrorInterface) =>
        `Digite pelo menos ${error.minLength} caracteres`,
      valueMissing: () => `Campo obrigatório`,
      rangeOverflow: (error: ValidationFormErrorInterface) => {
        if (
          error.inputType === 'date' &&
          error.max !== undefined &&
          error.max
        ) {
          const formattedDate = formataData(error.max)
          return `Deve ser menor ou igual a ${formattedDate}`
        } else {
          return `Deve ser menor ou igual que ${error.max}`
        }
      },
      rangeUnderflow: (error: ValidationFormErrorInterface) => {
        if (
          error.inputType === 'date' &&
          error.min !== undefined &&
          error.min
        ) {
          const formattedDate = formataData(error.min)
          return `Deve ser maior ou igual a ${formattedDate}`
        } else {
          return `Deve ser maior ou igual que ${error.min}`
        }
      },
      stepMismatch: (error: ValidationFormErrorInterface) =>
        `Menor valor possível é ${error.step}`,
      typeMismatch: (error: ValidationFormErrorInterface) =>
        `Digite um ${error.inputType}`
    } as ErrorMappingInterface,
    reset: 'Limpar',
    submit: 'Enviar'
  },
  general: {
    active: 'Ativo',
    add: 'Adicionar',
    addPhoto: 'Adicionar nova foto',
    addFiles: 'Adicionar novos arquivos',
    address: 'Endereço',
    all: 'Todos',
    back: 'Voltar',
    birthdate: 'Data de nascimento',
    cancel: 'Cancelar',
    apply: 'Aplicar',
    category: 'Categoria',
    clear: 'Limpar',
    checkAll: 'Marcar todos',
    checkDetails: 'Ver detalhes',
    city: 'Cidade',
    close: 'Fechar',
    code: 'Código',
    contact: 'Contato',
    contracts: 'Contratos',
    createdAt: 'Criado em',
    data: 'Dados',
    dataSavedSuccess: 'Dados salvos com sucesso!',
    description: 'Descrição',
    details: 'Detalhes',
    documents: 'Documentos',
    edit: 'Editar',
    email: 'E-mail',
    phone: 'Telefone',
    endDate: 'Data de término',
    filter: 'Filtros',
    initDate: 'Data de início',
    justification: 'Justificativa',
    lastUpdatedAt: 'Última atualização',
    leasedRealEstate: 'Imóveis locados',
    logo: 'Corretto',
    logout: 'Sair',
    maxPrice: 'Preço máximo',
    month: 'Mês',
    name: 'Nome',
    next: 'Próximo',
    noResultsFound: 'Não encontramos resultados para a sua busca...',
    notFilled: 'Não informado',
    number: 'Número',
    observation: 'Observações',
    openNewTab: 'Abrir',
    ownProperties: 'Imóveis próprios',
    photos: 'Fotos',
    price: 'Preço',
    prices: 'Preços',
    proposals: 'Propostas',
    property: 'Imóvel',
    rejectReason: 'Motivo de recusa',
    removePhoto: 'Remover foto',
    removeFile: 'Remover arquivo',
    save: 'Salvar',
    search: 'Buscar',
    select: 'Selecionar',
    send: 'Enviar',
    state: 'Estado',
    status: 'Situação',
    type: 'Tipo',
    update: 'Atualizar',
    updatedAt: 'Atualizado em',
    uncheckAll: 'Desmarcar todos',
    deleteProperty: 'Excluir imóvel',
    infoPhoto: 'Clique em uma foto para usar como capa',
    saveProperty: 'Salvar imóvel',
    propertyOverview: {
      title: 'Visão Geral do Imóvel',
      savedSuccessfully: 'Imóvel salvo com sucesso!',
      savedMessage: 'O imóvel foi cadastrado e está disponível no sistema.',
      propertySummary: 'Resumo do imóvel',
      backToList: 'Voltar à lista',
      viewOnSite: 'Ver no site',
      editProperty: 'Editar imóvel',
      propertyNotFound: 'Imóvel não encontrado'
    },
    priceNegotiation: 'Preço e Negociação',
    amenities: 'Comodidades',
    imagesAndDocuments: 'Imagens e Documentos',
    pickup: 'Captador',
    propertyPublication: 'Publicação do Imóvel',
    errorZipcode: 'Erro ao buscar dados',
    requiredFields: 'Preencha todos os campos obrigatórios',
    yes: 'Sim',
    no: 'Não',
    warningTitle: 'Atenção',
    cancelMessage:
      'Ao cancelar, os dados serão perdidos e será necessário realizar o cadastro novamente.',
    proceed: 'Prosseguir',
    noInformation: 'Não há informações disponíveis',
    view: 'Visualizar',
    delete: 'Excluir',
    your: 'Seu',
    saveChanges: 'Salvar alterações'
  },
  login: {
    copyright: (year: number) =>
      `© ${year} Corretto · uma empresa do Grupo Gomes Pimentel`,
    createUser: 'Criar conta',
    errors: {
      passwordMustContainNumber: `A senha deve conter pelo menos um número`,
      passwordMustContainUpperCase: `A senha deve conter pelo menos uma letra maiúscula`,
      passwordMustContainLowerCase: `A senha deve conter pelo menos uma letra minúscula`,
      passwordMustHaveLength: (length: number) =>
        `A senha deve conter pelo menos ${length} caracteres`,
      passwordMustMatch: 'As senhas não são iguais'
    },
    forgotPassword: 'Esqueci minha senha',
    password: 'Senha',
    newPassword: 'Nova Senha',
    confirmNewPassword: 'Confirmar Nova Senha',
    recoverPassword: 'Recuperar senha',
    signin: 'Entrar'
  },
  properties: {
    add: 'Novo imóvel',
    addNewProposal: 'Criar proposta',
    address: 'Endereço do imóvel',
    additionalParkingSpace: 'Vaga adicional de garagem',
    alreadyHaveProposal: 'Já possui uma proposta ativa',
    administrationFee: 'Taxa de administração',
    administrationFeeSale: 'Taxa de administração Venda',
    approximateValue: 'Valor aproximado',
    area: 'Área',
    bailInsurance: 'Seguro fiança',
    bathrooms: 'Banheiros',
    categories: {
      commercial: 'Comercial',
      residential: 'Residencial'
    } as Record<string, string>,
    checkWebsite: 'Ver imóvel no site',
    condominium: 'Condomínio',
    description: 'Dados do imóvel',
    edit: 'Editar imóvel',
    estimated: 'Estimados',
    footage: 'Metragem',
    fireInsurance: 'Seguro incêndio',
    includedInCondominium: 'Itens inclusos no condomínio',
    intermediationFee: 'Taxa de intermediação',
    intermediationFeeSale: 'Taxa de intermediação Venda',
    iptu: 'IPTU',
    itemsIncludedInCondominium: {
      reserveFund: 'Fundo de reserva',
      water: 'Água'
    },
    invalidZipCode: 'Formato de CEP inválido',
    minimumPrice: 'Valor mínimo aceito',
    neighborhood: 'Bairro',
    noPhoto:
      'Arraste as fotos do imóvel para esse quadro ou clique no botão abaixo para selecionar',
    noFile: 'Ainda não há arquivos adicionados',
    addFile:
      'Arraste os documentos do imóvel para esse quadro ou clique no botão abaixo para selecionar',
    parkingSpaces: 'Vagas de garagem',
    propertyData: 'Dados do imóvel',
    propertyDoesNotHaveContracts: 'O imóvel não possui contratos',
    propertyDoesNotHaveActiveContract: 'O imóvel não possui contrato ativo',
    propertyDoesNotHaveProposals: 'O imóvel não possui propostas',
    propertyNotRented: 'O imóvel ainda não foi locado',
    propertyNotOwned: 'O imóvel não possui dono',
    otherValues: 'Demais valores',
    rent: 'Aluguel',
    sale: 'Compra',
    registerPayment: 'Registrar pagamento',
    rooms: 'Quartos',
    kitchens: 'Cozinhas',
    sendPhoto: 'Enviar fotos',
    status: {
      available: 'Disponível para locação',
      awaitingSignature: 'Aguardando assinaturas',
      inactive: 'Inativo',
      pendingPhoto: 'Aguardando fotos',
      active: 'Ativo',
      pending: 'Pendente de aprovação',
      proposalInAnalysis: 'Proposta em análise',
      rent: 'Imóvel locado'
    },
    userActive: 'Ativo',
    userInactive: 'Inativo',
    targetPrice: 'Valor anunciado',
    title: 'Imóveis',
    total: 'Total',
    types: {
      apartment: 'Apartamento',
      house: 'Casa',
      kitnet: 'Kitnet',
      land: 'Terreno',
      room: 'Sala',
      shed: 'Galpão',
      store: 'Loja',
      studio: 'Studio',
      sobrado: 'Sobrado',
      chácara: 'Chácara',
      fazenda: 'Fazenda',
      cobertura: 'Cobertura',
      sítio: 'Sítio',
      rancho: 'Rancho',
      flat: 'Flat',
      point: 'Ponto',
      garage: 'Box/Garagem'
    } as Record<string, string>,
    zipCode: 'CEP',
    propertyOwner: 'Proprietário',
    indicateOrRegister: 'Deseja  indicar ou cadastrar um imóvel?',
    indicate: 'Indicar',
    register: 'Cadastrar',
    mensageNewPhoto: 'Para adicionar uma foto capa, clique em alguma image',
    mensagePhotoIsPrimary:
      'Para marcar uma nova foto como capa, delete a capa atual!',
    infoOwner: 'Informar proprietário',
    notInfoOwner: 'Não informar proprietário',
    approvals: {
      title: 'Imóveis aguardando aprovação',
      subtitle: 'imóvel(is) aguardando sua revisão',
      empty: 'Tudo em dia! Nenhum imóvel aguardando aprovação.',
      approve: 'Aprovar',
      reject: 'Rejeitar',
      rejectConfirm:
        'Tem certeza que deseja rejeitar este imóvel? Ele ficará inativo.',
      approveSuccess: 'Imóvel aprovado com sucesso',
      rejectSuccess: 'Imóvel rejeitado',
      submittedBy: 'Enviado por',
      ownerPhone: 'Telefone',
      captadorOwnerNote: 'Proprietário informado pelo captador',
      reviewAndEdit: 'Revisar e editar',
      alreadyDecided: 'Este imóvel já foi aprovado ou rejeitado',
      genericError: 'Ocorreu um erro. Tente novamente.',
      pendingNotice: 'Aguardando aprovação',
      pendingNoticeSubmittedBy: (name: string) =>
        `Aguardando aprovação — enviado por ${name}`,
      pendingNoticeHint:
        'Revise e complete os dados do imóvel. Ao aprovar, ele é publicado no site e o proprietário é avisado.'
    }
  },
  proposals: {
    add: 'Nova proposta',
    edit: 'Editar proposta',
    title: 'Propostas',
    proposalData: 'Dados da proposta',
    entryDate: 'Data de entrada',
    exitDate: 'Data de saída',
    counterProposalModal: 'Registrar Contra-Proposta',
    counterProposalConditions: 'Condições da contra-proposta',
    counterProposalValue: 'Novo valor proposto (R$)',
    status: {
      received: 'Recebida',
      analyzing: 'Em Análise',
      counterProposal: 'Contra-Proposta',
      contractGenerated: 'Contrato Gerado',
      accepted: 'Aceita',
      filling: 'Em Preenchimento',
      insuranceAnalysis: 'Em Análise - Seguro',
      valueAnalysis: 'Em Análise - Valor',
      rejected: 'Recusada',
      sentToAdmin: 'Enviada ao Administrativo',
      adminInfoRequested: 'Administrativo pediu informações',
      adminApproved: 'Aprovada pelo Administrativo',
      awaitingOwner: 'Com o proprietário',
      expired: 'Vencida',
      withdrawn: 'Desistência'
    } as Record<string, string>,
    pipeline: {
      title: 'Esteira de Contrato',
      viewPipeline: 'Ver esteira',
      viewList: 'Ver lista',
      sendToAdmin: 'Enviar para Administrativo',
      requestInfo: 'Solicitar mais informações',
      approve: 'Aprovar',
      reject: 'Reprovar',
      resendToAdmin: 'Responder e reenviar',
      generateContract: 'Gerar contrato',
      history: 'Histórico da esteira',
      comment: 'Comentário',
      commentOptional: 'Comentário (opcional)',
      noHistory: 'Nenhuma movimentação registrada ainda.',
      confirmSendToAdmin:
        'Enviar esta proposta para o administrativo gerar o contrato?',
      // Feature #632 — ficha de fechamento
      prepareClosing: 'Preparar fechamento',
      approveAndGenerate: 'Aprovar e gerar contrato',
      requestAdjustment: 'Pedir ajuste',
      clientWithdrew: 'Cliente desistiu',
      withdrawReason: 'Motivo da desistência',
      rejectReason: 'Motivo da reprovação',
      myQueue: 'Só a minha fila',
      awaitingAdmin: 'Aguardando administrativo',
      awaitingCommercial: 'Aguardando comercial',
      timeInStage: 'Na etapa',
      dropContractGenerated: 'Gere o contrato pela proposta.',
      dropSentToAdmin:
        'O envio ao administrativo é feito pela ficha de fechamento.'
    },
    closing: {
      title: 'Fechamento',
      formTitle: 'Ficha de fechamento',
      summaryTitle: 'Resumo do fechamento',
      nextStep: 'Próximo passo: preparar o fechamento',
      nextStepHint:
        'A ficha já vem preenchida com o que a proposta tem. Complete o que falta, anexe os documentos e envie para o administrativo.',
      waitingCommercial: 'O comercial está preparando a ficha de fechamento.',
      infoRequested: 'O administrativo pediu ajuste',
      infoRequestedBy: (name: string, date: string) =>
        [name && `Pedido por ${name}`, date && `em ${date}`]
          .filter(Boolean)
          .join(' '),
      completeness: (value: number) => `Ficha ${value}% completa`,
      fromProposal: 'da proposta',
      flagged: 'Pedido de ajuste',
      missing: 'Falta preencher',
      saveDraft: 'Salvar rascunho',
      sendToAdmin: 'Enviar para o administrativo',
      resend: 'Responder e reenviar',
      missingList: (fields: string) => `Falta para enviar: ${fields}`,
      draftSaved: 'Rascunho salvo',
      sent: 'Ficha enviada para o administrativo',
      confirmTitle: 'Enviar para o administrativo?',
      confirmHint:
        'O administrativo recebe este resumo e um aviso no sino. A ficha fica só para leitura até ele aprovar ou pedir ajuste.',
      reply: 'Resposta ao pedido de ajuste',
      replyOptional: 'Mensagem ao administrativo (opcional)',
      replyRequired: 'Escreva a resposta ao pedido de ajuste.',
      copySummary: 'Copiar resumo',
      copied: 'Copiado',
      copyFailed: 'Não foi possível copiar. Selecione o texto e copie.',
      copyField: 'Copiar',
      noDocuments: 'Nenhum documento anexado.',
      readOnly:
        'A ficha só pode ser editada com a proposta aceita ou com pedido de ajuste.',
      saleContractDisabled:
        'Ainda não há modelo de contrato de venda. Aprove a proposta e gere o contrato fora da plataforma.',
      submittedBy: (name: string, date: string) =>
        [name ? `Enviada por ${name}` : 'Enviada', date && `em ${date}`]
          .filter(Boolean)
          .join(' '),
      loadError: 'Não foi possível carregar a ficha de fechamento.',
      infoRequestTitle: 'Pedir ajuste ao comercial',
      infoRequestMessage: 'O que o comercial precisa ajustar',
      infoRequestMessageRequired: 'Descreva o que o administrativo precisa.',
      infoRequestFields: 'Campos a ajustar (opcional)',
      infoRequestHint:
        'Os campos marcados aparecem em destaque na ficha do comercial.',
      infoRequestSend: 'Enviar pedido'
    }
  },
  groupRoles: {
    admin: 'Administrador',
    customer: 'Usuário',
    employee: 'Funcionário'
  } as Record<string, string>,
  site: {
    home: {
      commercialProperties: {
        title: 'Imóveis comerciais',
        description:
          'Você pode encontrar apartamentos, casas e pontos comerciais para aluguel.',
        link: 'Quero ver todos os pontos comerciais'
      },
      lastRegisteredProperties: {
        description:
          'Nossos imóveis são todos certificados por profissionais da área e cada um deles tem sua documentação válida para aluguel.',
        title: 'Últimos imóveis cadastrados'
      },
      seeAlso: {
        description:
          'Você pode encontrar apartamentos, casas e pontos comerciais para aluguel.',
        title: 'Veja também',
        link: 'Quero ver todos os imóveis'
      }
    },
    favorites: {
      favoriteList: 'Lista de imóveis favoritos',
      favoriteListDescription:
        'Estes são os imóveis que você mais gostou e salvou para analisar depois.',
      mainBannerTitle: 'Seus imóveis favoritos',
      mainBannerSubtitle: 'Veja seus "queridinhos" da plataforma'
    },
    filter: {
      title: 'Imobiliária',
      subTitle: 'descomplicada',
      search: 'Filtro'
    },
    logo: {
      text: 'Seu imóvel sem burocracia'
    }
  },
  users: {
    add: 'Novo usuário',
    cpfCnpj: 'CPF/CNPJ',
    documents: 'Documentos',
    edit: 'Editar usuário',
    errors: {
      cpfFormat: 'Somente números ou XXX.XXX.XXX-XX',
      validContact: 'Somente números ou (XX)YXXXX-XXXX',
      duplicateContact:
        'Esse número de contato já foi adicionado anteriormente. Por favor, verifique sua lista de contatos.'
    },
    fullName: 'Nome/Razão social',
    new: 'Cadastrar usuário',
    newest: 'Mais recentes',
    noPhones: 'Não há telefones cadastrados',
    ownedProperties: 'Imóveis próprios',
    permissions: 'Permissões',
    personalData: 'Dados pessoais',
    ownerData: 'Dados do proprietário',
    phones: 'Telefones',
    phone: 'Telefone',
    registrationData: 'Dados cadastrais',
    rentedProperties: 'Imóveis alugados',
    rg: 'RG',
    role: 'Papel',
    search: 'Busque por um usuário',
    status: {
      active: 'Ativo',
      inactive: 'Inativo'
    } as Record<string, string>,
    title: 'Usuários',
    user: 'Usuário',
    types: {
      owner: 'Proprietário',
      tenant: 'Locatário'
    } as Record<string, string>,
    userNotOwnerProperty: 'O usuário não é dono de imóvel',
    userNotRentedProperty: 'O usuário não tem imóvel alugado',
    viewDetails: 'Ir para detalhes do usuário',
    otherInfo: 'Informações adicionais',
    saveAndAdvance: 'Salvar e avançar',
    registerOwner: 'Cadastrar proprietário',
    name: 'Nome',
    email: 'Email',
    birthdate: 'Data de nascimento',
    whatsApp: 'WhatsApp',
    accessProfile: 'Perfil de acesso',
    seeSummary: 'Ver resumo',
    management: 'Gestão de Usuários',
    profileType: 'Tipo de perfil',
    type: 'Tipo',
    renter: 'Locatário',
    ownProperties: 'Imóveis próprios',
    noPropertiesRented: 'O usuário não tem imóvel alugado',
    noOwnProperty: 'O usuário não é dono de imóvel',
    tabData: 'Dados',
    tabInterestProperties: 'Imóveis de Interesse',
    tabProposals: 'Propostas',
    tabContracts: 'Contratos',
    tabDocuments: 'Documentos',
    tabSearchProfile: 'Perfil de Busca',
    tabNotes: 'Anotações',
    internalNotes: 'Anotações internas',
    internalNotesHelper: 'Visível apenas para corretores da agência',
    notesPlaceholder: 'Adicione observações sobre este cliente...',
    notesSaved: 'Anotações salvas',
    notesAdd: 'Adicionar anotação',
    notesEmpty: 'Nenhuma anotação registrada para este usuário',
    notesLegacyTitle: 'Anotação inicial (legado)',
    searchProfileType: 'Tipo de imóvel',
    searchProfilePurpose: 'Finalidade',
    searchProfileMinPrice: 'Preço mínimo',
    searchProfileMaxPrice: 'Preço máximo',
    searchProfileNeighborhoods: 'Bairros de interesse',
    searchProfileSaved: 'Perfil de busca salvo',
    noLeads: 'Nenhum lead encontrado para este usuário',
    noProposals: 'Nenhuma proposta enviada por este usuário',
    noContracts: 'Nenhum contrato vinculado a este usuário',
    noDocumentsUser: 'Nenhum documento vinculado a este usuário',
    favoritesSectionTitle: 'Favoritos',
    noFavorites: 'Este usuário ainda não favoritou nenhum imóvel',
    recentViewsSectionTitle: 'Visualizados recentemente',
    noRecentViews: 'Nenhum imóvel visualizado recentemente por este usuário',
    relatedLeadsSectionTitle: 'Leads relacionados (funil comercial)',
    relatedLeadsSectionHelper:
      'Correspondência feita por e-mail, pode não representar o mesmo cadastro',
    contractRoleRenter: 'Locatário',
    contractRoleOwner: 'Proprietário',
    contractRoleBoth: 'Locatário e Proprietário',
    summaryFavorites: 'Imóveis favoritados',
    summaryProposals: 'Propostas',
    summaryActiveContracts: 'Contratos ativos',
    summaryNotes: 'Anotações',
    summaryLastActivity: 'Última atividade'
  },
  access: {
    management: 'Gestão de acesso',
    profile: 'Perfil',
    profileName: 'Nome do perfil',
    accessType: 'Tipo de acesso',
    permissions: 'Permissões',
    accessTypeEnum: {
      EXTERNAL: 'Externo',
      INTERNAL: 'Interno'
    } as Record<string, string>,
    subType: 'Subtipo de acesso',
    subTypeEnum: {
      CAPTADOR: 'Captador',
      CORRETOR: 'Corretor',
      ADMINISTRATIVO: 'Administrativo',
      COMERCIAL: 'Comercial',
      LOCADOR: 'Locador',
      INQUILINO: 'Inquilino',
      CORRETOR_PARCEIRO: 'Corretor Parceiro',
      CAPTADOR_PARCEIRO: 'Captador Parceiro'
    } as Record<string, string>,
    permissionsEnum: {
      REAL_STATE_REGISTRATION: 'Cadastro de imóvel',
      REAL_STATE_EDITING: 'Edição de imóvel',
      REAL_STATE_INACTIVATION: 'Desativação de imóvel',
      REAL_STATE_ACTIVATION: 'Ativação de imóvel',
      REAL_STATE_DELETE: 'Exclusão de imóvel',
      USER_REGISTRATION: 'Cadastro de usuário',
      USER_EDITING: 'Edição de usuário',
      USER_INACTIVATION: 'Desativação de usuário',
      USER_ACTIVATION: 'Ativação de usuário',
      USER_DELETE: 'Exclusão de usuário',
      ACCESS_PROFILE_REGISTRATION: 'Cadastro de perfil de acesso',
      ACCESS_PROFILE_EDITING: 'Edição de perfil de acesso',
      ACCESS_PROFILE_INACTIVATION: 'Desativação de perfil de acesso',
      ACCESS_PROFILE_ACTIVATION: 'Ativação de pefil de acesso',
      ACCESS_PROFILE_DELETE: 'Exclusão de perfil de acesso',
      EDIT_CAPTADOR_CO_CAPTADOR: 'Editar captador/co-captador',
      TASK_VIEW_ALL: 'Ver e atribuir tarefas de toda a equipe'
    }
  },
  visits: {
    title: 'Visitas'
  },
  stepsOwner: {
    searchOwner: 'Buscar Proprietário',
    searchNameCpf: 'Busque por nome ou cpf já cadastrado',
    registerOwner: 'Cadastrar proprietário',
    registerNewOwner: 'Cadastrar novo proprietário',
    name: 'Nome',
    phoneOne: 'Telefone 1',
    phoneTwo: 'Telefone 2',
    WhatsApp: 'WhatsApp',
    email: 'Email',
    cpfCnpj: 'CPF/CNPJ',
    rg: 'RG',
    birthdate: 'Data de nascimento',
    saveOwner: 'Salvar Proprietário',
    emailAlreadyRegistered: 'E-mail já cadastrado',
    confirmUpdateOwnerData:
      'Este e-mail já está cadastrado. Deseja atualizar os dados deste proprietário com as novas informações?',
    confirmUpdate: 'Sim, atualizar',
    keepExistingData: 'Não, manter existentes',
    confirmOwnerTitle: 'Confirmar proprietário selecionado',
    confirmOwnerDescription:
      'Confira os dados abaixo antes de preencher automaticamente o formulário com as informações deste proprietário.',
    confirmOwnerSelection: 'Confirmar e preencher dados'
  },
  condominiumLabels: {
    title: 'Condomínios cadastrados',
    name: 'Nome',
    add: 'Novo condomínio',
    responsible: 'Responsável',
    contact: 'Contato',
    numbersOfImoveis: 'Número de Imóveis',
    neighborhood: 'Bairro',
    actions: 'Ações',
    last: 'Mais recente',
    older: 'Mais antigo'
  },
  comodidadesTitle: {
    imovelOferece: 'O que seu Imóvel oferece?',
    caracteristicasImovel: 'Quais as características do imóvel?',
    tipoLazerImovel: 'Qual tipo de lazer do imóvel?',
    loalizacaoArmarios: 'Onde estão instalados os armários?',
    tipoAquecimento: 'Qual tipo de aquecimento?',
    tipoDePiso: 'Qual tipo de piso',
    tipoLazerCondominio: 'Qual lazer do condomínio?',
    infraCondominio: 'Qual a infraestrutura do seu condomínio?'
  },
  assortmentFilter: {
    show: 'Exibir',
    ordenation: 'Ordenação',
    showOptions: {
      all: 'Todos'
    },
    orderOptions: {
      latest: 'Mais recente primeiro',
      older: 'Mais antigo primeiro',
      lowestValue: 'Menor valor primeiro',
      greatestValue: 'Maior valor primeiro',
      sale: 'Venda',
      rent: 'Locação'
    }
  },
  advancedFilter: {
    federalityUnity: 'Estado',
    city: 'Cidade',
    neighborhood: 'Bairros',
    min: 'Mínimo',
    max: 'Máximo',
    tipoImovel: 'Tipo do Imóvel',
    finalidade: 'Finalidade',
    status: 'Status',
    qtdQuartos: 'Quantidade de Quartos',
    value: 'Valor de locação',
    propertyCode: 'Código do Imóvel'
  },
  propertyDescription: {
    cep: 'CEP',
    notCep: 'Não sei meu CEP',
    publicPlace: 'Logradouro',
    number: 'Número',
    neighborhood: 'Bairro',
    block: 'Bloco',
    complement: 'Complemento',
    city: 'Cidade',
    state: 'Estado',
    condominium: 'Condomínio',
    selectCondominium: 'Selecione o condomínio',
    registerCondominium: 'Cadastrar condomínio',
    cantSay: 'Não sei dizer',
    commercialDistrict: 'Bairro comercial',
    detailedInformation: 'Informações detalhadas',
    address: 'Endereço',
    purposeProperty: 'Finalidade do imóvel',
    propertyType: 'Tipo do imóvel',
    propertySubtype: 'Subtipo do imóvel',
    totalArea: 'Área total',
    totalAreaTooltip:
      'Área total é a soma de todas as áreas do imóvel, sendo ela maior que as demais',
    usefulArea: 'Área útil',
    usefulAreaTooltip:
      'Área útil é aquela interior ao imóvel, sendo a somatória das áreas dos cômodos internos desconsiderando garagens, varandas e paredes',
    privateArea: 'Área privativa',
    commonArea: 'Área comum',
    commonAreaTooltip:
      'São áreas com acesso comum, tanto dos moradores quanto dos convidados. São considerados, por exemplo, saguões, áreas de lazer e piscinas no cálculo',
    rightFoot: 'Pé direito',
    solarPosition: 'Posição Solar',
    floorNumber: 'Número do andar',
    occupation: 'Ocupação',
    locationKeys: 'Local das chaves do imóvel',
    specifyKeyLocation: 'Especifique abaixo',
    petAccepted: 'Aceita pet',
    furnished: 'Mobiliado',
    characteristics: 'Características',
    bedrooms: 'Quartos',
    kitchens: 'Cozinhas',
    howManySuites: 'Sendo quantas suítes',
    bathroom: 'Banheiros',
    bathroomTooltip: 'Considerando suítes, se existirem',
    toilet: 'Lavabos',
    rooms: 'Salas',
    parkingSpaces: 'Vagas de garagem',
    garageIdentifier: 'Identificador da vaga de garagem',
    description: 'Descrição do imóvel'
  },
  priceNegotiation: {
    sale: 'Venda',
    rent: 'Locação',
    businessType: 'Tipo de negócio',
    youCanSelectBothOptions: 'Você pode selecionar as duas opções',
    saleValue: 'Valor de venda',
    proprietaryFreeValue: 'Valor livre do proprietário',
    rentalValue: 'Valor da locação',
    tax: 'Taxas/Impostos',
    condominiumValue: 'Valor do condomínio',
    IptuValue: 'Valor do IPTU',
    ItrValue: 'Valor do ITR',
    IptuInstallment: 'Parcelamento do IPTU',
    warrantyTypes: 'Tipos de garantia',
    negotiation: 'Negociação',
    minimumSalesValue: 'Valor mínimo de venda',
    acceptFinancing: 'Aceita financiamento',
    minimumRentalAmount: 'Valor mínimo da locação',
    maximumRentalAmount: 'Valor máximo da locação',
    acceptExchange: 'Aceita permuta',
    administrationFee: 'Taxa de administração',
    proprietaryFreeValueWithAdministrationFee:
      'Valor livre do proprietário pós taxa de administração',
    intermediationFee: 'Taxa de intermediação',
    negotiationDetails: 'Detalhes da negociação',
    placeholderTextArea:
      'Informe aqui alguma particularidade da negociação, como por exemplo, imóvel de herança, financiamento pendente e etc...',
    confidentialInformation: 'Informações confidenciais',
    numberIptu: 'Número do IPTU',
    propertyRegistration: 'Matrícula do imóvel',
    energyMeterCode: 'Código do medidor de energia',
    waterMeterCode: 'Código do hidrômetro',
    gasMeterCode: 'Código do medidor de gás',
    writingSituation: 'Situação da escritura',
    registryOffice: 'Cartório de registro',
    dwell: 'Habite-se',
    exempt: 'Isento'
  },
  propertyPublication: {
    terms: 'Termos',
    hasPublicationTerm: 'Possui termo de publicação?',
    hasPropertySign: 'Possui placa no imóvel?',
    adStatus: 'Status do anúncio',
    sendTerm: 'Enviar termo de aceite ao proprietário',
    announcement: 'Anúncio',
    announcementDescription:
      'Escreva um texto detalhado do seu imóvel, destacando seus pontos fortes e diferenciais',
    title: 'Título',
    placeholderTitle:
      'Digite aqui um título para o anúncio e o card do seu imóvel...',
    propertyDescription: 'Descrição do imóvel',
    placeholderPropertyDescription: 'Faça uma descrição do imóvel...',
    labels: 'Labels do card',
    labelsHint: 'Badges exibidos sobre a imagem no site (máx. 3)'
  },
  pickup: {
    searchPickup: 'Buscar captador',
    placeholderSearchPickup: 'Pesquise por nome ou cpf já cadastrados',
    isIndication: 'Este imóvel foi indicado por alguém',
    searchCoPickup: 'Buscar Co-captador',
    registerPickup: 'Cadastrar captador',
    registerNewPickup: 'Cadastrar novo captador',
    registerCoPickup: 'Cadastrar co-captador',
    registerNewCoPickup: 'Cadastrar novo co-captador',
    savePickup: 'Salvar captador',
    saveCoPickup: 'Salvar co-captador',
    searchPickupComercial: 'Comercial'
  },
  registerCondominium: {
    new: 'Novo Condomínio',
    edit: 'Editar Condomínio',
    nameCondominium: 'Nome do condomínio',
    administrator: 'Administradora',
    registerAdministrator: 'Cadastrar administradora',
    phone: 'Telefone',
    email: 'Email',
    zipCode: 'CEP',
    neighborhood: 'Bairro',
    typeCondominium: 'Tipo de condomínio',
    saveCondominium: 'Salvar condomínio',
    notCep: 'Não sei meu cep',
    publicPlace: 'Logradouro',
    number: 'Número',
    state: 'Estado',
    referencePoint: 'Ponto de referência',
    city: 'Cidade',
    save: 'Salvar Condomínio'
  },
  propertiesSummary: {
    inactivePropertyTitle: 'Imóvel desativado',
    inactivePropertySubtitle: 'O imóvel foi desativado porque já foi vendido.',
    inactivateProperty: 'Desativar esse imóvel',
    reactivateProperty: 'Reativar esse imóvel',
    modal: {
      inactivatePropertySubtitle:
        'Se você desativar esse imóvel ele não poderá mais ser visto pelos clientes, ' +
        'mas seus dados cadastrais permanecerão salvos.',
      inactivationReasonPlaceholder:
        'Informe aqui o motivo da desativação do imóvel * (obrigatório)',
      reactivatePropertySubtitle:
        'Se você reativar esse imóvel, ele será novamente exibido aos clientes no site.',
      reactivationReasonPlaceholder:
        'Informe aqui o motivo da reativação do imóvel...',
      close: 'Fechar'
    },
    sections: {
      general: {
        user: {
          name: 'Nome',
          phone: 'Telefone',
          email: 'E-mail',
          cpfCnpj: 'CPF/CNPJ',
          rg: 'RG',
          dateOfBirth: 'Data de Nascimento'
        }
      },
      owner: {
        sectionTitle: 'Proprietário',
        emptyOwner: 'Não possui informações do proprietário.'
      },
      property: {
        sectionTitle: 'Dados do imóvel',
        address: {
          zipCode: 'CEP',
          street: 'Logradouro',
          number: 'Número',
          neighborhood: 'Bairro',
          city: 'Cidade',
          state: 'Estado'
        },
        block: 'Bloco',
        complement: 'Complemento',
        purpose: 'Finalidade',
        propertyType: 'Tipo do Imóvel',
        propertySubtype: 'Subtipo do imóvel',
        totalArea: 'Área total (m²)',
        usefulArea: 'Área útil (m²)',
        privateArea: 'Área Privada (m²)',
        commonArea: 'Área Comum (m²)',
        ceilingHeight: 'Pé direito (m)',
        solarPosition: 'Posição Solar',
        floor: 'Andar',
        occupation: 'Ocupação',
        keyLocation: 'Local das Chaves do Imóvel',
        acceptsPets: 'Aceita Pet',
        furnished: 'Mobiliado',
        rooms: 'Quartos',
        kitchens: 'Cozinhas',
        howManySuites: 'Sendo quantas suítes',
        bathrooms: 'Banheiros',
        washrooms: 'Lavabos',
        livingRooms: 'Salas',
        parkingSpaces: 'Vagas de Garagem',
        garageIdentifier: 'Identificador da vaga de Garagem',
        condominiumName: 'Condomínio',
        admName: 'Administradora'
      },
      priceNegotiation: {
        sectionTitle: 'Preço e Negociação',
        rent: 'Locação',
        sale: 'Venda',
        saleValue: 'Valor de Venda',
        rentValue: 'Valor da Locação',
        proprietaryFreeValue: 'Valor Livre do Proprietário',
        condoFee: 'Condomínio',
        propertyTax: 'IPTU',
        ruralPropertyTax: 'ITR',
        propertyTaxInstallment: 'Parcelamento IPTU',
        guaranteeTypes: 'Tipos de Garantia',
        minSaleValue: 'Valor Mínimo de Venda',
        financingAccepted: 'Aceita Financiamento',
        minRentValue: 'Valor Mínimo de Locação',
        maxRentValue: 'Valor Máximo de Locação',
        barterAccepted: 'Aceita Permuta',
        administrationFee: 'Taxa de Administração',
        administrationFeeSale: 'Taxa de Administração de Venda',
        intermediationFee: 'Taxa de Intermediação',
        intermediationFeeSale: 'Taxa de Intermediação de Venda',
        propertyTaxNumber: 'Número do IPTU',
        propertyRegistration: 'Matrícula do Imóvel',
        energyMeterCode: 'Código do Medidor de Energia',
        registryOffice: 'Cartório de Registro',
        occupancyPermit: 'Habite-se'
      },
      amenities: {
        sectionTitle: 'Comodidades',
        empty: 'Não ha dados'
      },
      imagesAndDocuments: {
        sectionTitle: 'Imagens e Documentos',
        images: 'Imagens',
        documents: 'Documentos',
        files: 'arquivo(s)',
        coverImage: 'Foto da capa',
        videoUrl: 'Url do video'
      },
      collector: {
        sectionTitle: 'Captador',
        collector: 'captador',
        cooCollector: 'co-captador',
        propertyIsIndicated: 'Esse imóvel foi indicado por alguém'
      },
      propertyPublication: {
        sectionTitle: 'Publicação do Imóvel',
        hasPublicationTerm: 'Possui termos de publicação',
        hasPropertySign: 'Possui placa no imóvel',
        announcementStatus: 'Status do anúncio'
      },
      emptyValue: '-',
      editIconText: 'Editar'
    }
  },
  propertiesInfo: {
    sale: 'Venda',
    location: 'Locação',
    sale_location: 'Venda e Locação',
    interestedInThisProperty: 'Interessado neste imóvel? Entre em contato!',
    name: 'Nome',
    phone: 'Telefone',
    email: 'E-mail',
    whatsApp: 'WhatsApp',
    writeHere: 'Digite aqui',
    sendInterest: 'Enviar interesse',
    successOnLeadCreate:
      'Interesse enviado com sucesso! Em breve um de nossos corretores irá entrar em contato com você'
  },
  simpleSummary: {
    deleteThis: 'Excluir esse',
    simpleModal: {
      registrationSavedSuccessfully: 'Cadastro salvo com sucesso!',
      hasSuccessfullyRegistered: 'foi cadastrado com sucesso!',
      successfullyRegistered: 'Cadastrado com sucesso!',
      doYouWantToViewThe: 'Deseja visualizar o',
      register: 'cadastro',
      viewRegister: 'Visualizar cadastro',
      checkEmail:
        'Verifique seu e-mail e siga as instruções para criar sua senha.'
    },
    close: 'Fechar',
    deleteUser: 'Excluir usuário',
    deleteUserMessage:
      'Se você excluir esse usuário, ele não existirá mais dentro do sistema.',
    noChangesOnRegister: 'Não houve alterações no cadastro',
    registrationUpdatedSuccessfully: 'Cadastro atualizado com sucesso!'
  },
  customize: {
    title: 'Personalizar Plataforma',
    subtitle:
      'Defina as cores e a logo da sua agência. As alterações são aplicadas imediatamente para todos os usuários.',
    sectionPresets: 'Paletas predefinidas',
    colorsScope:
      'Estas cores valem para o seu site e o portal dos seus clientes. O painel da Corretto mantém as cores da plataforma.',
    sectionColors: 'Cores personalizadas',
    sectionLogo: 'Logo da agência',
    primaryColor: 'Cor primária',
    secondaryColor: 'Cor secundária',
    buttonColor: 'Cor dos botões',
    primaryHelper: 'Usada em cabeçalhos, links e destaques',
    secondaryHelper: 'Usada em menus e elementos de apoio',
    buttonColorHelper:
      'Aplicada em todos os botões de ação da plataforma (Buscar, Ver detalhes, Entrar...)',
    logoDescription: 'Formatos aceitos: PNG, JPG, SVG. Tamanho máximo: 5 MB.',
    logoEmpty: 'Sem logo',
    logoSelect: 'Selecionar arquivo',
    logoFileSelected: 'Arquivo selecionado:',
    faviconSection: 'Ícone do site (favicon)',
    faviconDescription:
      'Aparece na aba do navegador e nos favoritos do seu site. Use uma imagem quadrada, de preferência só o símbolo da marca.',
    faviconFormats:
      'Formatos aceitos: PNG quadrado (mínimo 48 × 48 px), SVG ou ICO. Tamanho máximo: 1 MB. PNG maior que 256 px é reduzido para 256 × 256.',
    faviconScope:
      'Vale para o seu site e o portal dos seus clientes. O painel mantém o ícone da Corretto.',
    faviconSelect: 'Selecionar ícone',
    faviconUseDefault: 'Usar o padrão',
    faviconFileSelected: 'Arquivo selecionado:',
    faviconDefaultLabel: 'Ícone padrão da Corretto',
    faviconRemovePending:
      'O ícone padrão da Corretto volta a valer quando você salvar.',
    faviconPreviewTab: 'Na aba do navegador',
    faviconPreviewSizes: 'Nos favoritos e na tela de início do iPhone',
    faviconErrorFormat: 'Formato não aceito. Envie um arquivo PNG, SVG ou ICO.',
    faviconErrorTooLarge: 'O arquivo passa de 1 MB. Envie um ícone menor.',
    faviconErrorNotSquare:
      'O PNG precisa ser quadrado (mesma largura e altura).',
    faviconErrorTooSmall: 'O PNG precisa ter no mínimo 48 × 48 px.',
    faviconErrorUnreadable:
      'Não foi possível ler a imagem. Verifique o arquivo e tente novamente.',
    faviconPartialSave:
      'As outras alterações foram salvas, mas o ícone não. Tente de novo.',
    faviconUploadError:
      'Erro ao enviar o ícone do site. Verifique o formato e tente novamente.',
    faviconRemoveError: 'Erro ao voltar para o ícone padrão. Tente novamente.',
    save: 'Salvar alterações',
    discard: 'Descartar alterações',
    previewTitle: 'Preview ao vivo',
    previewDescription:
      'As cores abaixo refletem as suas seleções antes de salvar.',
    sectionCardStyle: 'Estilo dos cards de imóveis',
    cardStyleDescription:
      'Escolha como os imóveis são exibidos na busca e na página inicial.',
    sectionHeaderStyle: 'Estilo do cabeçalho',
    headerStyleDescription:
      'Define a aparência do menu de navegação exibido no topo da plataforma.',
    sectionFooterStyle: 'Layout do rodapé',
    footerStyleDescription:
      'Escolha a estrutura visual do rodapé exibido em todas as páginas públicas.',
    sectionFont: 'Tipografia',
    fontDescription:
      'Família tipográfica aplicada em toda a plataforma pública.',
    sectionHeroStyle: 'Banner da página inicial',
    heroStyleDescription:
      'Define o layout e visual do banner exibido no topo da tela inicial.',
    heroImageLabel: 'Imagem de fundo customizada',
    heroImageDescription:
      'Substitui a imagem padrão do banner. Formatos: PNG, JPG, WEBP. Máx: 5 MB.',
    heroImageSelect: 'Selecionar imagem',
    heroImageFileSelected: 'Arquivo selecionado:',
    heroOverlayPreview: 'Preview do overlay',
    heroOverlayColor: 'Cor do overlay',
    heroOverlayColorHelper: 'Cor aplicada sobre a imagem de fundo como filtro.',
    heroOverlayOpacity: 'Opacidade do overlay',
    heroOverlayOpacityHelper: 'Quanto mais alto, mais a cor cobre a imagem.',
    saveSuccess: 'Configurações salvas com sucesso',
    saveError: 'Erro ao salvar as configurações. Tente novamente.',
    logoUploadError:
      'Erro ao enviar a logo. Verifique o formato e tente novamente.',
    menuItem: 'Personalizar',
    tabColors: 'Cores & Identidade',
    tabCards: 'Cards de Imóveis',
    tabLayout: 'Cabeçalho & Layout',
    tabPropertyPage: 'Tela do Imóvel',
    propertyPageTitle: 'Configurações da Tela Pública do Imóvel',
    propertyPageSubtitle:
      'Escolha quais informações serão exibidas na página pública de detalhes do imóvel.',
    toggleShowPrice: 'Valor do imóvel',
    toggleShowCondominium: 'Taxa de condomínio',
    toggleShowIptu: 'IPTU',
    toggleShowPropertyCode: 'Código do imóvel',
    toggleShowMap: 'Mapa de localização',
    toggleShowDescription: 'Descrição do imóvel',
    toggleShowAmenities: 'Comodidades',
    toggleShowPropertySummary: 'Resumo (quartos, vagas, área)',
    toggleShowProposalButton: 'Botão "Fazer proposta"',
    toggleShowLeadButton: 'Botão "Tenho interesse"',
    toggleShowWhatsappButton: 'Botão WhatsApp',
    toggleShowFavoriteButton: 'Botão Favoritar',
    toggleShowShareButton: 'Botão Compartilhar',
    toggleShowSimilarProperties: 'Imóveis semelhantes',
    tabDashboard: 'Dashboard',
    dashboardTabTitle: 'Configurações do Dashboard Inicial',
    dashboardTabSubtitle:
      'Escolha quais KPIs e módulos serão exibidos no dashboard inicial da sua imobiliária.',
    toggleDashboardCarteira: 'Carteira de Imóveis',
    toggleDashboardTopImoveis: 'Métricas de Imóveis (Top Imóveis)',
    toggleDashboardPipeline: 'Pipeline Comercial',
    toggleDashboardPropostasKpi: 'KPIs de Propostas',
    toggleDashboardLeadOrigem: 'Origem de Leads',
    toggleDashboardReceita: 'Receita e Contratos',
    toggleDashboardAtividadeRecente: 'Histórico de Últimas Ações',
    toggleDashboardMyDay: 'Meu Dia (tarefas do usuário)'
  },
  conversations: {
    title: 'Conversas',
    connectionTitle: 'Conexão WhatsApp',
    configure: 'Configurar',
    connect: 'Conectar',
    disconnect: 'Desconectar',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    connecting: 'Conectando...',
    scanQrCode: 'Escaneie o QR Code com o WhatsApp',
    searchPlaceholder: 'Buscar conversa...',
    typeMessage: 'Digite uma mensagem',
    noConversationSelected: 'Selecione uma conversa para começar',
    editName: 'Editar nome',
    nameSaved: 'Nome atualizado com sucesso',
    urlLabel: 'URL da UazAPI',
    tokenLabel: 'Token da Instância',
    save: 'Salvar configuração'
  },
  performance: {
    sectionTitle: 'Desempenho',
    views: 'Visualizações',
    leads: 'Leads',
    proposals: 'Propostas',
    contracts: 'Contratos',
    visits: 'Visitas',
    favorites: 'Favoritos',
    daysPublished: 'Dias Publicado',
    noLeads: 'Nenhum lead associado a este imóvel',
    leadsSubtitle: 'Leads que mencionaram este imóvel',
    funnelTitle: 'Funil de Conversão',
    conversionRate: 'Taxa de Conversão',
    viewsLast30Days: 'Visualizações (30 dias)',
    leadsByOrigin: 'Origem dos Leads',
    proposalsByStatus: 'Propostas por Status',
    conversionTime: 'Tempo Médio de Conversão',
    daysLeadToVisit: 'Lead → Visita',
    daysLeadToProposal: 'Lead → Proposta',
    daysProposalToContract: 'Proposta → Contrato',
    days: 'dias',
    noData: 'Sem dados suficientes',
    avgProposalPrice: 'Ticket Médio Proposta',
    totalContractRevenue: 'Receita em Contratos',
    visitBreakdownTitle: 'Status das Visitas',
    visitScheduled: 'Agendadas',
    visitCompleted: 'Realizadas',
    visitCancelled: 'Canceladas',
    // Feature #89
    visitsCompleted: 'Visitas realizadas',
    daysOnMarket: 'Dias no mercado',
    noneYet: 'nenhum ainda',
    noneYetFem: 'nenhuma ainda',
    emptyState: 'Este imóvel ainda não gerou leads, visitas ou propostas.',
    scheduledVisits: (n: number) =>
      `+${n} ${n === 1 ? 'agendada' : 'agendadas'}`,
    proposalsSentAccepted: (sent: number, accepted: number) =>
      `${sent} ${sent === 1 ? 'enviada' : 'enviadas'} · ${accepted} ${
        accepted === 1 ? 'aceita' : 'aceitas'
      }`,
    proposalsSentToOwner: (n: number) =>
      `${n} ${n === 1 ? 'enviada' : 'enviadas'} ao proprietário`,
    lastLeadDaysAgo: (days: number) =>
      days <= 0
        ? 'último hoje'
        : `último há ${days} ${days === 1 ? 'dia' : 'dias'}`,
    publishedDaysAgo: (days: number) =>
      days <= 0
        ? 'publicado hoje'
        : `publicado há ${days} ${days === 1 ? 'dia' : 'dias'}`
  },
  sectors: {
    title: 'Setores',
    menuItem: 'Setores',
    create: 'Criar setor',
    edit: 'Editar setor',
    delete: 'Excluir setor',
    members: 'Membros',
    addMember: 'Adicionar membro',
    assignSector: 'Atribuir setor',
    noSector: 'Sem setor',
    allSectors: 'Todos'
  },
  audioAmenity: {
    fill: 'Preencher por áudio',
    recording: 'Gravando... Clique para parar',
    processing: 'Identificando comodidades...',
    success: 'comodidades identificadas!',
    error: 'Erro ao processar áudio. Tente novamente.',
    micDenied:
      'Permissão de microfone negada. Habilite nas configurações do navegador.'
  },
  audioPricing: {
    fill: 'Preencher por áudio',
    recording: 'Gravando... Clique para parar',
    processing: 'Extraindo informações...',
    success: 'campos preenchidos automaticamente!',
    error: 'Erro ao processar áudio. Tente novamente.',
    micDenied:
      'Permissão de microfone negada. Habilite nas configurações do navegador.'
  },
  audioDetails: {
    fill: 'Preencher por áudio',
    recording: 'Gravando... Clique para parar',
    processing: 'Extraindo detalhes...',
    success: 'campos preenchidos automaticamente!',
    error: 'Erro ao processar áudio. Tente novamente.',
    micDenied:
      'Permissão de microfone negada. Habilite nas configurações do navegador.'
  },
  aiDescription: {
    template: 'Template de IA',
    noTemplate: 'Sem template',
    generate: 'Gerar com IA',
    generating: 'Gerando...',
    undo: 'Desfazer',
    notesLabel: 'Observações para a IA (opcional)',
    notesPlaceholder:
      'Pontos de referência, estado de conservação, diferenciais... A IA só usa o que estiver no cadastro e aqui.',
    dictate: 'Ditar',
    stopDictation: 'Parar',
    transcribing: 'Transcrevendo...',
    audioError: 'Não foi possível transcrever o áudio. Tente novamente.',
    noData: 'Preencha as informações do imóvel antes de gerar a descrição.',
    empty: 'Não foi possível gerar a descrição. Tente novamente.',
    error: 'Erro ao conectar com o serviço de IA. Tente novamente.',
    replaceTitle: 'Substituir a descrição?',
    replaceText:
      'A descrição atual será trocada pelo texto gerado. Depois dá para desfazer.',
    replaceConfirm: 'Substituir',
    cancel: 'Cancelar',
    generated: 'Descrição gerada. Revise antes de publicar.'
  },
  ocrAutofill: {
    title: 'Preencher por foto / documento',
    subtitle:
      'Tire uma foto ou envie uma imagem da ficha do imóvel para preencher os campos automaticamente',
    uploadButton: 'Enviar imagem',
    cameraButton: 'Tirar foto',
    captureButton: 'Fotografar',
    processing: 'Analisando imagem...',
    success: 'campos preenchidos automaticamente!',
    error: 'Erro ao processar imagem. Tente novamente.',
    nothingFound:
      'Não encontramos dados do imóvel nesta imagem. Tente uma foto mais nítida da ficha.',
    rateLimited:
      'Muitas leituras ao mesmo tempo. Aguarde 1 minuto e clique em Analisar de novo.',
    cameraDenied:
      'Permissão de câmera negada. Habilite nas configurações do navegador.',
    analyze: 'Analisar e preencher',
    retake: 'Trocar imagem'
  },
  serviceTickets: {
    title: 'Chamados',
    menuItem: 'Manutenção',
    myTickets: 'Meus Chamados',
    newTicket: 'Novo Chamado',
    detail: 'Detalhe do Chamado',
    status: {
      OPEN: 'Aberto',
      IN_PROGRESS: 'Em Andamento',
      WAITING_APPROVAL: 'Aguardando Aprovacao',
      WAITING_SUPPLIER: 'Aguardando Fornecedor',
      SCHEDULED: 'Agendado',
      RESOLVED: 'Resolvido',
      CLOSED: 'Encerrado',
      CANCELLED: 'Cancelado'
    },
    category: {
      HYDRAULIC: 'Hidraulica',
      ELECTRICAL: 'Eletrica',
      STRUCTURAL: 'Estrutural',
      LOCKSMITH: 'Chaveiro',
      PAINTING: 'Pintura',
      APPLIANCE: 'Eletrodomesticos',
      CLEANING: 'Limpeza',
      PEST_CONTROL: 'Dedetizacao',
      KEY_MANAGEMENT: 'Gestao de Chaves',
      GENERAL: 'Geral',
      OTHER: 'Outros'
    },
    priority: {
      LOW: 'Baixa',
      MEDIUM: 'Media',
      HIGH: 'Alta',
      URGENT: 'Urgente'
    }
  },
  tasks: {
    title: 'Tarefas',
    menuItem: 'Tarefas',
    newTask: 'Nova tarefa',
    editTask: 'Editar tarefa',
    tabMyDay: 'Meu Dia',
    tabAll: 'Todas',
    overdueGroup: 'Atrasadas',
    todayGroup: 'Hoje',
    completedTodayGroup: 'Concluídas hoje',
    seeDayOf: 'Ver o dia de:',
    seeAll: 'Ver tudo',
    empty: 'Nenhuma tarefa encontrada',
    emptyMyDay: 'Nada pendente para hoje. Bom trabalho!',
    completed: 'Tarefa concluída',
    reopened: 'Tarefa reaberta',
    undo: 'Desfazer',
    created: 'Tarefa criada',
    updated: 'Tarefa atualizada',
    deleted: 'Tarefa excluída',
    deleteConfirm: 'Excluir esta tarefa?',
    automatic: 'Criada automaticamente pelo sistema',
    unassigned: 'Sem responsável',
    me: 'Eu',
    createFollowUp: 'Criar follow-up',
    fields: {
      title: 'Título',
      description: 'Descrição',
      dueDate: 'Vencimento',
      dueTime: 'Hora (opcional)',
      priority: 'Prioridade',
      status: 'Status',
      assignee: 'Responsável',
      lead: 'Lead',
      property: 'Imóvel',
      contract: 'Contrato',
      chat: 'Conversa',
      search: 'Buscar',
      due: 'Vencimento',
      linkType: 'Vínculo',
      origin: 'Origem'
    },
    shortcuts: {
      today: 'Hoje',
      tomorrow: 'Amanhã',
      in3Days: 'Em 3 dias',
      nextWeek: 'Próxima semana'
    },
    status: {
      PENDING: 'Pendente',
      IN_PROGRESS: 'Em andamento',
      DONE: 'Concluída'
    } as Record<string, string>,
    priority: {
      LOW: 'Baixa',
      MEDIUM: 'Média',
      HIGH: 'Alta',
      URGENT: 'Urgente'
    } as Record<string, string>,
    dueFilter: {
      OVERDUE: 'Atrasadas',
      TODAY: 'Hoje',
      NEXT_7_DAYS: 'Próximos 7 dias',
      RANGE: 'Período'
    } as Record<string, string>,
    linkType: {
      LEAD: 'Lead',
      CONTRACT: 'Contrato',
      REAL_ESTATE: 'Imóvel',
      CHAT: 'Conversa'
    } as Record<string, string>,
    origin: {
      MANUAL: 'Manual',
      AUTOMATIC: 'Automática'
    } as Record<string, string>
  },
  captador: {
    dashboard: {
      title: 'Meus imóveis cadastrados',
      empty: 'Nenhum imóvel cadastrado ainda',
      emptyDescription: 'Clique em "Cadastrar novo imóvel" para começar.',
      newProperty: 'Cadastrar novo imóvel'
    },
    novoImovel: {
      title: 'Cadastrar novo imóvel',
      success:
        'Imóvel cadastrado com sucesso! Aguardando aprovação da imobiliária.',
      error: 'Erro ao cadastrar imóvel. Tente novamente.',
      submit: 'Enviar para aprovação',
      sending: 'Enviando...'
    },
    status: {
      PENDING: 'Aguardando aprovação',
      ACTIVE: 'Aprovado',
      INACTIVE: 'Rejeitado'
    } as Record<string, string>
  }
}

const inputNameFormat = (inputName: string | undefined) => {
  switch (inputName) {
    case 'email-condominio':
      return 'email'
    case 'cpfCnpj':
      return 'CPF/CNPJ'
    default:
      return inputName
  }
}

export default translations
